var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98201",
    "data-name": "Group 98201",
    transform: "translate(-119 -169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_887",
    "data-name": "Ellipse 887",
    cx: 87,
    cy: 87,
    r: 87,
    transform: "translate(119 169)",
    fill: "#fafaff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(156.518 204.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_252947976",
    transform: "translate(10.482 10.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_252948384",
    d: "M112.371,93.144A19.154,19.154,0,1,1,93.217,112.3,19.154,19.154,0,0,1,112.371,93.144Zm6.34,9.2,3.635,3.635L116,112.329l6.349,6.349-3.635,3.635-6.349-6.349-6.349,6.349-3.635-3.635,6.349-6.349-6.349-6.349,3.635-3.635,6.349,6.349Z",
    transform: "translate(-47.743 -47.751)",
    fill: "#e2e2f8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_252948696",
    d: "M32.679,10.554H17.54a1.484,1.484,0,0,0-1.479,1.479v4.753a3.347,3.347,0,0,1-3.155,3.332,2.58,2.58,0,0,0-2.425,2.568V71.73a7.919,7.919,0,0,0,2.1,5.376,7.807,7.807,0,0,0,10.666.461,6.841,6.841,0,0,0,2.631-4.623l4.4-39.449a5.943,5.943,0,0,1,1.494-3.262,4.023,4.023,0,0,1,2.965-1.383H74.5V22.687a2.581,2.581,0,0,0-2.57-2.57H38.844a3.325,3.325,0,0,1-3.238-2.526L34.114,11.67a1.446,1.446,0,0,0-1.435-1.115Z",
    transform: "translate(-10.482 -10.554)",
    fill: "#e2e2f8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_252948360",
    d: "M45.662,47.23a2.215,2.215,0,0,0-1.605.786,4.008,4.008,0,0,0-1.007,2.2l-4.4,39.449a8.674,8.674,0,0,1-3.322,5.874q-.283.225-.584.43l30.728,0A21.03,21.03,0,0,1,93.256,71.878l3.521-22.223a1.874,1.874,0,0,0-.6-1.606,2.862,2.862,0,0,0-1.986-.819Zm.963,34.491H62.082l-1.241,6.413H45.385Z",
    transform: "translate(-21.408 -27.072)",
    fill: "#e2e2f8",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankIcon);
export default __webpack_public_path__ + "static/media/blank_icon.f1bdfb8578eef437d711663c539defb5.svg";
export { ForwardRef as ReactComponent };